import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";
import Modal from "../../resources/js/Modal.js";

const Oneonone = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [typePara, setTypePara] = useState("1"); // 기본값 설정

  const [phoneNum, setPhoneNum] = useState(""); // 상태 추가
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");

  const [sido, setSido] = useState(""); // 상태 훅 정의
  const [zipcode, setZipcode] = useState("");
  const [gungu, setGungu] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  const [isChecked, setIsChecked] = useState(false);

  const [selectedOption, setSelectedOption] = useState("");
  const [sidoList, setSidoList] = useState([]);
  const [gunguList, setGunguList] = useState([]);

  const [selectedFileName, setSelectedFileName] = useState(""); // file2의 선택된 파일 이름
  const [, setFile1Name] = useState(""); // file1 이름 상태
  const [, setFile2] = useState(null); // file2 상태

  // const [otherInput, setOtherInput] = useState(""); // 기타 입력값 상태 추가

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 1:1 문의`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  // ************************************** 전화번호 ******************************************************//

  // Handle phone number input change
  const handlePhoneNumChange = (event) => {
    const newValue = event.target.value.replace(/[^0-9]/g, "");
    if (newValue.length <= 11) {
      setPhoneNum(newValue);
    }
    validatePhoneNumber(newValue);
  };

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^(010|)\d{8}$/;
    if (!phoneRegex.test(number)) {
      setPhoneErrorMessage("올바른 전화번호 형식이 아닙니다.(010만 가능)");
    } else {
      setPhoneErrorMessage("");
    }
  };

  // *************************************** 주소 API *****************************************************//

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    script.async = true;
    script.onload = () => {
      // Postcode API가 로드된 후에 사용할 수 있습니다.
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up script on unmount
    };
  }, []);

  const getDaumPostcode = () => {
    new window.daum.Postcode({
      oncomplete: function (data) {
        let addr = "";
        if (data.userSelectedType === "R") {
          addr = data.roadAddress;
        } else {
          addr = data.jibunAddress;
        }

        let extraAddr = "";
        if (data.userSelectedType === "R") {
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            extraAddr += data.bname;
          }
          if (data.buildingName !== "" && data.apartment === "Y") {
            extraAddr +=
              extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
          }
          if (extraAddr !== "") {
            extraAddr = " (" + extraAddr + ")";
          }
        }

        // 요소 ID 확인
        const zipcodeField = document.getElementById("zipcode");
        const addr1Field = document.getElementById("addr1");
        const addr2Field = document.getElementById("addr2");
        const sidoField = document.getElementById("sido_i");
        const gunguField = document.getElementById("gungu_i");

        // 요소가 존재할 때만 값을 설정
        if (addr1Field) {
          addr1Field.value = addr + extraAddr;
        }
        if (zipcodeField) {
          setZipcode(data.zonecode);
          zipcodeField.value = data.zonecode;
          console.log("Zipcode:", zipcodeField.value);
        }
        if (addr2Field) {
          addr2Field.focus();
        }
        if (sidoField) {
          setSido(data.sido);
          sidoField.value = data.sido;
          console.log("Sido:", sidoField.value);
        }
        if (gunguField) {
          setGungu(data.sigungu);
          gunguField.value = data.sigungu;
          console.log("Gungu:", gunguField.value);
        }
      },
    }).open();
  };

  // ****************************************************************
  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden"; // 스크롤 막기
  };

  const handleClose = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto"; // 원래대로 되돌리기
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFileName(file.name);
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:.T]/g, "")
        .slice(0, 14);
      const extension = file.name.split(".").pop();
      setFile1Name(`${timestamp}_.${extension}`); // file1 이름 상태 업데이트
      setFile2(file); // file2 상태 업데이트
    } else {
      setSelectedFileName("");
      setFile1Name(""); // 파일이 선택되지 않은 경우
    }
  };

  // *******************spring에서 데이터 가져오기***************************************
  useEffect(() => {
    const fetchSidoList = async () => {
      try {
        const response = await fetch("/adress/sido");
        const result = await response.json();
        setSidoList(result);
      } catch (error) {
        console.error("Error fetching sido list:", error);
      }
    };

    fetchSidoList();
  }, []);

  const handleSidoChange = async (event) => {
    const selectedSido = event.target.value;
    console.log("Selected Sido:", selectedSido);
    setSido(selectedSido);

    try {
      const response = await fetch(`/adress/gungu?sido=${selectedSido}`);
      console.log("Fetch URL:", `/adress/gungu?sido=${selectedSido}`); // 추가된 로그
      const result = await response.json();
      console.log(result); // API 응답 확인

      // sigunguName만 추출하여 gunguList에 저장
      const sigunguNames = result.map((gungu) => gungu.sigunguName);
      console.log("Sigungu Names:", sigunguNames); // 추출된 시군구 이름 확인
      setGunguList(sigunguNames);
    } catch (error) {
      console.error("Error fetching gungu list:", error);
      setGunguList([]);
    }
  };

  useEffect(() => {
    console.log("Updated gunguList:", gunguList);
  }, [gunguList]); // gunguList가 변경될 때마다 로그 찍기

  const handleGunguChange = (event) => {
    const selectedGungu = event.target.value;
    setGungu(selectedGungu);
  };

  //****************************** spring에 데이터 전송 ************************************
  const handleSubmit = async (event) => {
    event.preventDefault(); // 기본 제출 동작 방지

    // 현재 활성화된 폼 ID를 가져옵니다.
    const form = document.getElementById(`writeform${typePara}`);

    // 공통적인 검증 로직
    const name = form.name.value;
    if (!name) {
      alert("이름은 필수 입력항목입니다.");
      return;
    }

    const cell = form.cell.value;
    if (!cell) {
      alert("휴대폰번호는 필수 입력항목입니다.");
      return;
    }

    // 각 폼에 따른 추가 검증 로직
    if (typePara === "1") {
      const baby_age = form.baby_age.value;
      if (!baby_age) {
        alert("자녀나이는 필수 입력항목입니다.");
        return;
      }

      const addr1 = form.addr1.value;
      if (!addr1) {
        alert("주소는 필수 입력항목입니다.");
        return;
      }

      const addr2 = form.addr2.value;
      if (!addr2) {
        alert("상세주소는 필수 입력항목입니다.");
        return;
      }
    } else if (typePara === "2") {
      const asobiRoot = form.asobiRoot.value;
      if (!asobiRoot) {
        alert("유입 경로는 필수 선택항목입니다.");
        return;
      }

      // "기타" 선택 여부 체크
      if (asobiRoot === "기타") {
        const asobiRootEtc = form.asobiRootEtc.value;
        if (!asobiRootEtc) {
          alert("기타 입력은 필수 항목입니다.");
          return;
        }
      }

      const sub_gubun = form.sub_gubun.value;
      if (!sub_gubun) {
        alert("교육원 형태는 필수 선택항목입니다.");
        return;
      }

      const sido = form.sido.value;
      if (!sido) {
        alert("시도는 필수 선택항목입니다.");
        return;
      }

      if (!gungu && sido !== "세종특별자치시") {
        alert("시군구는 필수 선택항목입니다.");
        return;
      }
    } else if (typePara === "3") {
		const sido = form.sido.value;
		if (!sido) {
		  alert("시도는 필수 선택항목입니다.");
		  return;
		}

		if (!gungu && sido !== "세종특별자치시") {
		  alert("시군구는 필수 선택항목입니다.");
		  return;
		}
    } else if (typePara === "4") {
      const sub_gubun = form.sub_gubun.value;
      if (!sub_gubun) {
        alert("카테고리는 필수 선택항목입니다.");
        return;
      }

      const baby_school = form.baby_school.value;
      if (!baby_school) {
        alert("교육원명은 필수 입력 항목입니다.");
        return;
      }

      const os = form.os.value;
      if (!os) {
        alert("os버전은 필수 선택 항목입니다.");
        return;
      }

      const device_type = form.device_type.value;
      if (!device_type && os !== "und") {
        alert("기종입력은 필수 입력항목입니다.");
        return;
      }
    }

    // typePara 3, 4, 5에 대한 추가 검증 로직도 여기에 추가
    const content = form.content.value;
    if (!content) {
      alert("문의사항은 필수 입력항목입니다.");
      return;
    }

    if (phoneErrorMessage) {
      alert("올바른 전화번호 형식이 아닙니다.(010만 가능)");
      return;
    }

    if (!isChecked) {
      alert("개인정보 수집 및 활용에 동의해 주세요.");
      return;
    }

    // 신청 정보 확인
    const confirmation = window.confirm(`입력하신 정보로 신청하시겠습니까?`);
    if (!confirmation) {
      return;
    }

    const formData = new FormData(form);
    formData.set("gubun", getGubunByTypePara(typePara)); // typePara에 따라 gubun 설정

    try {
      const response = await fetch("/asobiForm", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      alert("신청이 완료되었습니다.");
      window.location.reload();
    } catch (error) {
      console.error("에러 발생:", error);
      alert("신청 중 에러가 발생했습니다.");
    }
  };

  const getGubunByTypePara = (typePara) => {
    switch (typePara) {
      case "1":
        return "BB04";
      case "2":
        return "BB01";
      case "3":
        return "BB06";
      case "4":
        return "BB07";
      default:
        return "";
    }
  };

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/customer">상담 문의</a>
              </li>
              <li>
                <a href="/oneonone" className="sel">
                  1:1 문의
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title">고객센터</div>
          <div className="text">아소비에 궁금한 점은 빠르게 해결하세요!</div>
          <div className="image">
            <img src="../custom-resources/img/sub_customer_bg.png" alt="" />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">고객센터</span>
            </div>
            <div className="menu">
              <a href="/customer">상담문의</a>
              <a href="/oneonone" className="on">
                1:1 문의
              </a>
            </div>
          </div>
        </div>
        <div className="oneonone">
          <div className="sect oneonone01">
            <div className="wrap">
              <div className="tit">1:1 문의</div>
              <div className="select">
                <select
                  name="gubun"
                  id="select-form"
                  value={typePara} // 상태를 선택 요소와 연결
                  onChange={(e) => setTypePara(e.target.value)} // 상태 업데이트
                >
					<option value="1">입회 문의</option>
					<option value="2">창업 문의</option>
					<option value="3">지사장 문의</option>
					{/* <option value="4">앱</option> */}
                </select>
              </div>
              <div className="box init">
                <div className="top">
                  <div className="img">
                    <img src="../custom-resources/img/img_oneonone_ico.png" alt="" />
                  </div>
                  <div className="con">
                    <p>
                      아소비는 여러분의 작은 의견에도 귀를 기울입니다.
                      <br />
                      궁금하신 점이 있으시거나 의견이 있으시다면 언제든 아소비의
                      문을 두드려주세요.
                    </p>
                  </div>
                </div>
              </div>

              <div className="form init">
                {typePara === "1" && (
                  <div className="type01_view">
                    <form
                      id="writeform1"
                      name="writeform1"
                      method="post"
                      enctype="multipart/form-data"
                    >
                      <input type="hidden" name="gubun" value="BB04" />
                      <dl>
                        <dt>
                          문의 주제 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input type="text" value="입회 문의" readOnly />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          작성자 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="name"
                            placeholder="자녀이름"
                            title="자녀이름"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          연락처 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="cell"
                            placeholder="전화번호(’-’없이 입력해주세요)"
                            title="전화번호"
                            maxLength="11"
                            value={phoneNum}
                            onChange={handlePhoneNumChange}
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          자녀 나이 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <select
                            name="baby_age"
                            className="required1"
                            title="자녀나이"
                          >
                            <option value="">자녀나이</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                          </select>
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          주소 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            id="addr1"
                            name="addr1"
                            title="주소"
                            placeholder="클릭 해주세요"
                            className="required1"
                            onClick={getDaumPostcode}
                          />
                          <input
                            type="hidden"
                            id="address_extra"
                            placeholder="참고항목"
                          />
                          <input
                            type="hidden"
                            name="sido"
                            id="sido_i"
                            value={sido}
                          />
                          <input
                            type="hidden"
                            name="gungu"
                            id="gungu_i"
                            value={gungu}
                          />
                          <input
                            type="hidden"
                            name="zipcode"
                            id="zipcode"
                            value={zipcode}
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          상세주소 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            id="addr2"
                            name="addr2"
                            title="상세주소"
                            placeholder="상세주소"
                            className="required1"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          문의 사항 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <textarea
                            name="content"
                            title="문의사항"
                            placeholder="내용을 입력하세요"
                            className="required1"
                          ></textarea>
                        </dd>
                      </dl>
                    </form>
                  </div>
                )}
                {typePara === "2" && (
                  <div className="type02_view">
                    <form
                      id="writeform2"
                      name="writeform2"
                      method="post"
                      enctype="multipart/form-data"
                    >
                      <input type="hidden" name="gubun" value="BB01" />
                      <dl>
                        <dt>
                          문의 주제 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input type="text" value="창업 문의" readOnly />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          작성자 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="name"
                            className="required2"
                            placeholder="이름"
                            title="이름"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          연락처 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="cell"
                            className="required2"
                            placeholder="전화번호(’-’없이 입력해주세요)"
                            title="전화번호"
                            maxLength="11"
                            value={phoneNum}
                            onChange={handlePhoneNumChange}
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          유입 경로 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <select
                            name="asobiRoot"
                            id="asobiRoot"
                            className="required2"
                            title="유입 경로"
                            value={selectedOption}
                            onChange={handleChange}
                          >
                            <option value="">유입 경로</option>
                            <option value="인터넷 검색">인터넷 검색</option>
                            <option value="온라인 광고">온라인 광고</option>
                            <option value="인근 아소비">인근 아소비</option>
                            <option value="인쇄 홍보물">인쇄 홍보물</option>
                            <option value="지인 소개">지인 소개</option>
                            <option value="공식 카페">공식 카페</option>
                            <option value="맘카페">맘카페</option>
                            <option value="기타">기타</option>
                          </select>
                          {selectedOption === "기타" && (
                            <input
                              type="text"
                              name="asobiRootEtc"
                              id="asobiRootEtc"
                              placeholder="기타 입력"
                              title="기타 입력"
                            />
                          )}
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          교육원 형태 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <select
                            name="sub_gubun"
                            className="required2"
                            title="교육원 형태"
                          >
                            <option value="">교육원 형태 </option>
                            <option value="A">공부방형</option>
                            <option value="B">학원형</option>
                          </select>
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          희망 지역 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <select
                            name="sido"
                            id="sido_list2"
                            onChange={handleSidoChange}
                            className="required2"
                            title="희망지역"
                          >
                            <option value="">시도선택</option>
                            {sidoList.map((sido) => (
                              <option
                                key={sido.sigunguCode}
                                value={sido.sidoName}
                              >
                                {sido.sidoName}
                              </option>
                            ))}
                          </select>
                          <input type="hidden" name="addr1" value={sido} />
                          <select
                            name="gungu"
                            id="gungu_list2"
                            title="시군구"
                            onChange={handleGunguChange}
                          >
                            <option value="">시군구</option>
                            {gunguList.length > 0 ? (
                              gunguList.map((gungu, index) => (
                                <option key={index} value={gungu}>
                                  {gungu} {/* 여기서 gungu는 문자열입니다 */}
                                </option>
                              ))
                            ) : (
                              <option value="">시군구가 없습니다.</option>
                            )}
                          </select>
                          <input
                            type="hidden"
                            name="addr2"
                            value={gungu}
                          ></input>
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          문의 사항 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <textarea
                            name="content"
                            className="required2"
                            title="문의사항"
                            placeholder="내용을 입력하세요"
                          ></textarea>
                        </dd>
                      </dl>
                    </form>
                  </div>
                )}
                {typePara === "3" && (
                  <div className="type03_view">
                    <form
                      id="writeform3"
                      name="writeform3"
                      method="post"
                      enctype="multipart/form-data"
                    >
                      <input type="hidden" name="gubun" value="BB06" />
                      <dl>
                        <dt>
                          문의 주제 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input type="text" value="지사장 문의" readOnly />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          작성자 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="name"
                            className="required3"
                            placeholder="이름"
                            title="이름"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          연락처 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="cell"
                            className="required3"
                            placeholder="전화번호(’-’없이 입력해주세요)"
                            title="전화번호"
                            maxLength="11"
                            value={phoneNum}
                            onChange={handlePhoneNumChange}
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          희망 지역 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <select
                            name="sido"
                            id="sido_list3"
                            onChange={handleSidoChange}
                            className="required3"
                            title="희망지역"
                          >
                            <option value="">시도선택</option>
                            {sidoList.map((sido) => (
                              <option
                                key={sido.sigunguCode}
                                value={sido.sidoName}
                              >
                                {sido.sidoName}
                              </option>
                            ))}
                          </select>
                          <input type="hidden" name="addr1" value={sido} />
                          <select
                            name="gungu"
                            id="gungu_list3"
                            title="시군구"
                            onChange={handleGunguChange}
                          >
                            <option value="">시군구</option>
                            {gunguList.length > 0 ? (
                              gunguList.map((gungu, index) => (
                                <option key={index} value={gungu}>
                                  {gungu}
                                </option>
                              ))
                            ) : (
                              <option value="">시군구가 없습니다.</option>
                            )}
                          </select>
                          <input
                            type="hidden"
                            name="addr2"
                            value={gungu}
                          ></input>
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          문의 사항 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <textarea
                            name="content"
                            className="required3"
                            title="문의사항"
                            placeholder="내용을 입력하세요"
                          ></textarea>
                        </dd>
                      </dl>
                      <dl>
                        <dt>첨부 파일</dt>
                        <dd>
                          <label className="file">
                            <input
                              id="upload2"
                              name="file2"
                              type="file"
                              className="inputtext"
                              onChange={handleFileChange}
                            />
                            <i>파일 선택</i>
                            <span>
                              {selectedFileName || "선택된 파일 없음"}
                            </span>
                          </label>
                        </dd>
                      </dl>
                    </form>
                  </div>
                )}
                {typePara === "4" && (
                  <div className="type04_view">
                    <form
                      id="writeform4"
                      name="writeform4"
                      method="post"
                      enctype="multipart/form-data"
                    >
                      <input type="hidden" name="gubun" value="BB07" />
                      <dl>
                        <dt>
                          문의 주제 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input type="text" value="앱 문의" readOnly />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          작성자 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="name"
                            className="required4"
                            placeholder="이름"
                            title="이름"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          연락처 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="cell"
                            className="required4"
                            placeholder="전화번호(’-’없이 입력해주세요)"
                            title="전화번호"
                            maxLength="11"
                            value={phoneNum}
                            onChange={handlePhoneNumChange}
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          카테고리 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <select
                            name="sub_gubun"
                            id="sub_gubun4"
                            className="required4"
                            title="카테고리"
                          >
                            <option value="학부모">학부모</option>
                            <option value="교육원">교육원</option>
                            <option value="지사">지사</option>
                          </select>
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          교육원명 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            name="baby_school"
                            type="text"
                            className="required4"
                            placeholder="교육원명 입력"
                            title="교육원명"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          OS 버전 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <select
                            name="os"
                            id="os4"
                            className="required4"
                            title="OS 버전"
                          >
                            <option value="android">Android</option>
                            <option value="ios">IOS</option>
                            <option value="und">모름</option>
                          </select>
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          기종 입력 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            name="device_type"
                            type="text"
                            className="required4"
                            placeholder="핸드폰 기종 입력"
                            title="기종 입력"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          문의 사항 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <textarea
                            name="content"
                            className="required4"
                            placeholder="내용을 입력하세요"
                            title="문의 사항"
                          ></textarea>
                        </dd>
                      </dl>
                      <dl>
                        <dt>첨부 파일</dt>
                        <dd>
                          <label className="file">
                            <input
                              id="upload4"
                              name="file2"
                              type="file"
                              className="inputtext"
                              onChange={handleFileChange}
                            />
                            <i>파일 선택</i>
                            <span>
                              {selectedFileName || "선택된 파일 없음"}
                            </span>
                          </label>
                        </dd>
                      </dl>
                    </form>
                  </div>
                )}
                {/* {typePara === "5" && (
                  <div className="type05_view">
                    <form
                      name="writeform5"
                      method="post"
                      onSubmit="return check5();"
                      enctype="multipart/form-data"
                    >
                      <input type="hidden" name="gubun" value="BB02" />
                      <input type="hidden" name="pre" value="one" />
                      <dl>
                        <dt>
                          문의 주제 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input type="text" value="기타 문의" readOnly />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          작성자 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="name5"
                            value=""
                            className="required5"
                            placeholder="이름"
                            title="이름"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          연락처 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="cell5"
                            value=""
                            className="required5"
                            placeholder="전화번호(’-’없이 입력해주세요)"
                            title="전화번호"
                            onKeyDown="onlyNumberInput();"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          주제 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <input
                            type="text"
                            name="title5"
                            value=""
                            className="required5"
                            placeholder="주제"
                            title="주제"
                          />
                        </dd>
                      </dl>
                      <dl>
                        <dt>
                          문의 사항 <em style={{ color: "red" }}>*</em>
                        </dt>
                        <dd>
                          <textarea
                            name="content5"
                            className="required5"
                            placeholder="내용을 입력하세요"
                            title="문의 사항"
                          ></textarea>
                        </dd>
                      </dl>
                      <dl>
                        <dt>첨부 파일</dt>
                        <dd>
                          <label className="file">
                            <input
                              id="upload5"
                              name="upload5"
                              type="file"
                              className="inputtext"
                            />
                            <i>파일 선택</i>
                            <span>선택된 파일 없음</span>
                          </label>
                        </dd>
                      </dl>
                    </form>
                  </div>
                )} */}
              </div>

              <div className="check">
                <label className="agree">
                  <input
                    type="checkbox"
                    name="agree_ck"
                    id="agree_ck"
                    className="required"
                    title="개인정보 수집동의"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <i></i>
                  <p>개인 정보 수집 및 활용 동의</p>
                  <button id="popTerms" onClick={handleOpen}>
                    [내용 보기]
                  </button>
                </label>
                <div className={`popupTerms ${isOpen ? "active" : ""}`}>
                  <Modal isOpen={isOpen} onClose={handleClose}>
                    <div className="cont">
                      - 수집목적 : 서비스 제공을 위한 이용자 식별 및 본인 여부
                      확인, 계약 이행을 위한 연락민원등 고객 고충 처리
                      <br />
                      - 수집항목 : 신청자명, 휴대폰번호
                      <br />
                      - 보유기간 : 작성 후 1년 이내
                      <br />
                      ※ 서비스 제공을 위해서 필요한 최소한의 개인정보이므로
                      동의를 해 주셔야 서비스를 이용하실 수 있습니다.
                      <br />
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="help">
                ※ 작성하신 사항을 확인하시고 버튼을 눌러주세요. 본사에서
                확인하는대로 연락드리겠습니다.
              </div>
              <div className="button">
                <button
                  type="submit"
                  className="btn btn_01"
                  onClick={handleSubmit}
                >
                  작성하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Oneonone;
